<template>
  <svg
    width="16"
    height="16"
    viewBox="2 2 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :style="fillStyle"
      fill-rule="evenodd"
      d="m15 17.837-1.856-5.567 5.568-5.569L15 17.837Zm2.298-12.55-5.568 5.568-5.568-1.856 11.136-3.712Zm4.692-2.34a.951.951 0 0 0-.088-.361.967.967 0 0 0-.195-.294.96.96 0 0 0-.384-.23.987.987 0 0 0-.275-.054c-.022-.001-.042-.006-.065-.006-.1.002-.201.016-.299.048l-18 6a1 1 0 0 0 0 1.898l8.525 2.842 2.843 8.526a.998.998 0 0 0 1.896 0l6-18a1 1 0 0 0 .048-.299c.001-.024-.005-.046-.006-.07Z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
import widgetSettings from '@/widget-settings';

export default {
  props: {
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fillStyle() {
      if (this.inverted) {
        return { fill: '#ffffff' };
      }
      return { fill: widgetSettings.color };
    }
  }
};
</script>
